import React from 'react'
import COLOR from '../../global/Color'

import HeaderContainer from '../../components/header/HeaderContainer'
import HeaderTitle from '../../components/header/HeaderTitle'
import HeaderContent from '../../components/header/HeaderContent'
import HeaderContentSmall from '../../components/header/HeaderContentSmall'
import ContentContainer from '../../components/content/ContentContainer'
import ContentTitle from '../../components/content/ContentTitle'
import ContentBox from '../../components/content/ContentBox'
import InnerItem from '../../components/inner/company/InnerItem'
import ContentContainerClear from '../../components/content/ContentContainerClear'
import ContentTitleBlack from '../../components/content/ContentTitleBlack'
import TableBox from '../../components/inner/company/TableBox'

import backgroundImage from '../../assets/company/aboutbackgroundImage.png'

import TableImage01 from '../../assets/company/why01.png'
import TableImage02 from '../../assets/company/why02.png'
import TableImage03 from '../../assets/company/why03.png'
import TableImage04 from '../../assets/company/why04.png'
import { useLanguage } from '../../context/LanguageContext';
import { siteCopy } from '../../i18n/landingCopy';

const tableImages = [TableImage01, TableImage02, TableImage03, TableImage04];

const About = () => {
  const { language } = useLanguage();
  const copy = siteCopy[language]?.pages?.company?.about || siteCopy.en.pages.company.about;
  const [firstBody = "", secondBody = ""] = copy.bodyParagraphs ?? [];
  const cards = copy.cards || [];
  const tableRows = copy.tableRows || [];

  const data = tableRows.map((text, index) => ({
    image: tableImages[index],
    text,
  }));

  return (
    <>
      <HeaderContainer>
        <HeaderTitle>{copy.headerTitle}</HeaderTitle>
        <HeaderContent>
          {copy.leadParagraph}
        </HeaderContent>
        
        <HeaderContentSmall>
          {firstBody}
        </HeaderContentSmall>

        <HeaderContentSmall>
          {secondBody}
        </HeaderContentSmall>

      </HeaderContainer>

      <ContentContainer backgroundImage={backgroundImage}>
        <ContentTitle>{copy.contentTitle}</ContentTitle>
        <ContentBox>
          <div style={{width: '73%', display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gridTemplateRows: 'repeat(2, 1fr)', gap: 20}}>
            {cards.map((card) => (
              <InnerItem
                key={card.title}
                Title={card.title}
                Content1={card.content1}
                Content2={card.content2}
                Content3={card.content3}
              />
            ))}
          </div>
        </ContentBox>

      </ContentContainer>

      <ContentContainerClear>
        <ContentTitleBlack>{copy.whyTitle}</ContentTitleBlack>
        <ContentBox>
          <TableBox data={data}/>
        </ContentBox>
      </ContentContainerClear>

    </>
  )
}
export default About
